var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailEquipamentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72.569,
    height: 83,
    viewBox: "0 0 72.569 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1378",
    "data-name": "Ret\\xE2ngulo 1378",
    width: 65.569,
    height: 75.255,
    transform: "translate(0 0)",
    fill: "#d3ff9a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3018",
    "data-name": "Grupo 3018",
    transform: "translate(-148 -159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3015",
    "data-name": "Grupo 3015",
    transform: "translate(155 159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3014",
    "data-name": "Grupo 3014",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_442",
    "data-name": "Caminho 442",
    d: "M32.784,75.249a1.512,1.512,0,0,1-.75-.2L.75,56.985a1.5,1.5,0,0,1-.75-1.3V19.563a1.5,1.5,0,0,1,.75-1.3L32.034.2a1.5,1.5,0,0,1,1.5,0L64.818,18.264a1.5,1.5,0,0,1,.75,1.3V55.686a1.5,1.5,0,0,1-.75,1.3L33.534,75.048a1.509,1.509,0,0,1-.75.2M3,54.82l29.784,17.2,29.784-17.2V20.429L32.784,3.233,3,20.429Z",
    fill: "#d3ff9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_443",
    "data-name": "Caminho 443",
    d: "M32.792,53.7a1.5,1.5,0,0,1-1.5-1.5V37.616a1.5,1.5,0,0,1,3,0V52.2a1.5,1.5,0,0,1-1.5,1.5",
    fill: "#d3ff9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_444",
    "data-name": "Caminho 444",
    d: "M32.792,75.255a1.5,1.5,0,0,1-1.5-1.5V63.1a1.5,1.5,0,0,1,3,0V73.755a1.5,1.5,0,0,1-1.5,1.5",
    fill: "#d3ff9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_445",
    "data-name": "Caminho 445",
    d: "M32.783,39.125a1.487,1.487,0,0,1-.749-.2L.75,20.861a1.5,1.5,0,1,1,1.5-2.6L33.534,36.326a1.5,1.5,0,0,1-.751,2.8",
    fill: "#d3ff9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_446",
    "data-name": "Caminho 446",
    d: "M32.785,39.125a1.5,1.5,0,0,1-.751-2.8L63.318,18.264a1.5,1.5,0,1,1,1.5,2.6L33.534,38.923a1.487,1.487,0,0,1-.749.2",
    fill: "#d3ff9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_447",
    "data-name": "Caminho 447",
    d: "M17.143,30.093a1.5,1.5,0,0,1-.751-2.8L47.676,9.232a1.5,1.5,0,0,1,1.5,2.6L17.892,29.891a1.487,1.487,0,0,1-.749.2",
    fill: "#d3ff9a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_90",
    "data-name": "Elipse 90",
    transform: "translate(180 189)",
    fill: "#1e1e1e",
    stroke: "#d3ff9a",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_87",
    "data-name": "Elipse 87",
    transform: "translate(148 170)",
    fill: "#1e1e1e",
    stroke: "#d3ff9a",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_88",
    "data-name": "Elipse 88",
    transform: "translate(148 208)",
    fill: "#1e1e1e",
    stroke: "#d3ff9a",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_85",
    "data-name": "Elipse 85",
    transform: "translate(180 227)",
    fill: "#1e1e1e",
    stroke: "#d3ff9a",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailEquipamentIcon);
export default __webpack_public_path__ + "static/media/detailEquipamentIcon.7ca579fca255cb7cde171eaa39f2ef51.svg";
export { ForwardRef as ReactComponent };